import { z } from 'zod/v4';

import { majorRegionSchema } from './major-region.schema';
import { regionDetailsSchema } from './region-details.schema';

export const fullRegionSchema = z.object({
  majorRegions: z.array(majorRegionSchema),
  regionDetails: regionDetailsSchema,
});

export type FullRegion = z.infer<typeof fullRegionSchema>;
